export const GET_ACCOUNT = "getAccount";
export const UPDATE_ACCOUNT = "updateAccount";
export const ADD_STUDENT = "addStudent";
export const UPDATE_STUDENT = "updateStudent";
export const DELETE_STUDENT = "deleteStudent";
export const GET_SUBJECTS = "getSubjects";
export const GET_TEACHERS = "getTeachers";
export const GET_EXAMFEES = "getExamFees";
export const GET_TEACHER = "getTeacher";
export const GET_PARENTS = "getParents";
export const GET_PARENTSTOTAL = "getParentsTotal";
export const GET_EXAMS = "getExams";
export const GET_EXAMSTOTAL = "getExamsTotal";
export const UPDATE_EXAM = "updateExam";
export const GET_SCHOOLYEAR = "getSchoolYear";
export const GET_SCHOOLYEARS = "getSchoolYears";
export const UPDATE_SCHOOLYEAR = "updateSchoolYear";
export const ADD_SCHOOLYEAR = "addSchoolYear";
export const SET_SCHOOLYEAR = "setSchoolYear";
export const UPDATE_TEACHER = "updateTeacher";
export const GET_TRANSACTIONS = "getTransactions";
export const GET_CREDITRECORDS = "getCreditRecords";
export const ADD_CREDITRECORD = "addCreditRecord";
export const DELETE_SCHOOLYEAR = "deleteSchoolYear";
export const DELETE_PARENT = "deleteParent";
export const UPDATE_EXAMFEE = "updateExamFee";
export const GET_LOCATIONS = "getLocations";
export const UPDATE_LOCATION = "updateLocation";
export const ADD_LOCATION = "addLocation";
export const DELETE_LOCATION = "deleteLocation";
export const GET_PENDINGACCOUNTS = "getPendingAccounts";
export const DELETE_PENDINGACCOUNT = "deletePendingAccount";
